import { FC, useState } from "react";
import { StyleSheet, Text, TextInput, TouchableOpacity, View } from "react-native";
import { kColors } from "src/kColors";
// import { createNewMessageThreads } from "src/redux/messages/actions";

type tMessageModalProps = {
  onDismiss: () => void;
};

const MessageModal: FC<tMessageModalProps> = ({ onDismiss }) => {
  const [sMessageRecipients, setMessageRecipients] = useState<string>("");

  const submitNewMessageThread = () => {
    // const aMessageRecipients = sMessageRecipients.split(", ");
    // createNewMessageThreads(aMessageRecipients, { [aMessageRecipients[0]]: "Jason Bright" });
    onDismiss();
  };

  return (
    <View style={styles.modalContainer}>
      <View style={styles.modal}>
        <Text style={styles.modalHeader}>New Message Thread</Text>
        <TextInput value={sMessageRecipients} onChangeText={setMessageRecipients} />
        <View style={styles.modalButtons}>
          <TouchableOpacity onPress={onDismiss} style={styles.marginLeft}>
            <Text style={styles.secondaryButton}>Cancel</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={submitNewMessageThread} style={styles.marginLeft}>
            <Text style={styles.primaryButton}>Create New Message Thread</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default MessageModal;

const styles = StyleSheet.create({
  marginLeft: {
    marginLeft: 16,
  },
  modal: {
    backgroundColor: kColors.white,
    maxWidth: "90%",
    position: "absolute",
    shadowColor: kColors.black,
    shadowOffset: { height: 5, width: 5 },
    shadowOpacity: 0.1,
    shadowRadius: 20,
    width: 600,
  },
  modalButtons: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 50,
    paddingHorizontal: 20,
  },
  modalContainer: {
    alignItems: "center",
    backgroundColor: kColors.transparentWhite,
    bottom: 0,
    justifyContent: "center",
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 10,
  },
  modalHeader: {
    flex: 1,
    fontSize: 22,
    fontWeight: "normal",
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  primaryButton: {
    color: kColors.brandDarkGreen,
    fontSize: 14,
    textAlign: "center",
    textTransform: "uppercase",
  },
  secondaryButton: {
    color: kColors.brandDarkGreen,
    fontSize: 14,
    paddingHorizontal: 16,
    paddingVertical: 10,
    textAlign: "center",
    textTransform: "uppercase",
  },
});
